import { render, staticRenderFns } from "./EmailMonitoring.vue?vue&type=template&id=616be0b1&scoped=true"
import script from "./EmailMonitoring.vue?vue&type=script&lang=js"
export * from "./EmailMonitoring.vue?vue&type=script&lang=js"
import style0 from "./EmailMonitoring.vue?vue&type=style&index=0&id=616be0b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616be0b1",
  null
  
)

export default component.exports